import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';
import ItemWrapper from 'components/organisms/overview-dashboard-filter/item-wrapper';
import ClinicFilterSelectBoxV2 from 'components/molecules/include-clinic-select-box';
import DoctorSelectBox from 'components/molecules/doctor-select-box';
import PatientSelectBox from 'components/molecules/patient-select-box';
import RpmStatusSelectBox from 'components/molecules/rpm-status-select-box';
import EngagementAttemptsSelectBox from 'components/molecules/engagement-attempts-select-box';

import s from './styles.module.scss';

import type { TPatientEngagementReportFilter } from 'infrastructure/hooks/patient-engagement-report';

interface IProps {
  filter: TPatientEngagementReportFilter;
  count: number;
  updateFilter: (newFilter: Partial<TPatientEngagementReportFilter>) => void;
  resetFilter: () => void;
}

const ExpandablePatientEngagementReportFilters: React.FC<IProps> = (props) => {
  const { filter, count, updateFilter, resetFilter } = props;
  const { t } = useTranslation();

  return (
    <ExpandableFilterPanel
      filtersCount={count}
      onReset={resetFilter}
      openWithValue
      isExpanded
    >
      <div className={s.row}>
        <ItemWrapper label={t('labels.patientFilter')}>
          <PatientSelectBox
            allowClear
            clinicGuid={filter.clinicGuid}
            doctorGuid={filter.doctorGuid}
            placeholder={t('labels.searchPatient')}
            value={filter.patientGuid}
            onChange={(patientGuid) => {
              updateFilter({ patientGuid, page: undefined });
            }}
          />
        </ItemWrapper>
        <ItemWrapper label={t('labels.status')}>
          <RpmStatusSelectBox
            allowClear
            value={filter.status}
            onChange={(status) => {
              updateFilter({ status: status ?? undefined, page: undefined });
            }}
          />
        </ItemWrapper>
        <ItemWrapper label={t('labels.engagementAttempts')}>
          <EngagementAttemptsSelectBox
            allowClear
            allowSearch
            placeholder={t('labels.search')}
            value={filter.engagementAttempts}
            onChange={(engagementAttempts) => {
              updateFilter({
                engagementAttempts: engagementAttempts ?? undefined,
                page: undefined,
              });
            }}
          />
        </ItemWrapper>
        <ItemWrapper label={t('labels.clinic')}>
          <ClinicFilterSelectBoxV2
            useAdminApi
            showOnInteractiveTimeDashboard={false}
            included={filter.clinicGuid}
            parentClinicGuid={filter.parentClinicGuid}
            onChange={({ included, parentClinicGuid }) => {
              updateFilter({
                clinicGuid: included ?? [],
                parentClinicGuid: parentClinicGuid ?? [],
                doctorGuid: undefined,
                patientGuid: undefined,
                page: undefined,
              });
            }}
            withoutLabel
          />
        </ItemWrapper>
        <ItemWrapper label={t('labels.provider')}>
          <DoctorSelectBox
            allowClear
            clinicGuid={filter.clinicGuid}
            placeholder={t('labels.search')}
            value={filter.doctorGuid}
            onChange={(doctorGuid) => {
              updateFilter({
                doctorGuid,
                patientGuid: undefined,
                page: undefined,
              });
            }}
          />
        </ItemWrapper>
      </div>
    </ExpandableFilterPanel>
  );
};

export default ExpandablePatientEngagementReportFilters;
